// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { DataEventProps } from "../../../../libraries/wpl/foundations/src/index";
import { Button } from "../../../wpl/button/src/index";

import BannerBody from "./banner-body";
import BannerTitle from "./banner-title";

export type BannerProps = {
    title: string;
    body: string;
    linkText: string;
    linkUrl: string;
    dataEventProps: DataEventProps;
};

export const Banner = ({
    title,
    body,
    linkText,
    linkUrl,
    dataEventProps
}: BannerProps) => {
    const bannerStyle = css`
        box-sizing: border-box;
        container-type: inline-size;

        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
        align-content: stretch;

        margin: 0;
        padding: ${token("space.250")};
        width: 100%;

        font-size: ${token("space.200")};

        color: #42526e;
        background: #e6fcff;
        border-radius: 3px;
    `;

    const bannerLeftStyle = css`
        width: 66.66%;
        display: flex;
        flex-flow: column wrap;
        justify-content: flex-end;
        align-items: flex-start;
        align-content: center;
    `;

    const bannerRightStyle = css`
        ${media.above.sm} {
            padding-left: ${token("space.100")};
        }

        ${UNSAFE_media.below.sm} {
            flex-basis: 100%;
            margin-top: ${token("space.250")};
        }

        display: flex;
        justify-content: flex-end;
    `;

    const buttonStyle = css`
        ${UNSAFE_media.below.sm} {
            flex-basis: 100%;
        }

        font-size: ${token("space.200")};
        font-weight: normal;

        :hover,
        :focus,
        :active {
            background: transparent;
        }
    `;

    return (
        <div css={bannerStyle}>
            <div css={bannerLeftStyle}>
                <BannerTitle>{title}</BannerTitle>
                <BannerBody>{body}</BannerBody>
            </div>
            <div css={bannerRightStyle}>
                <Button
                    css={buttonStyle}
                    text={linkText}
                    url={linkUrl}
                    type="secondary"
                    dataEventProps={dataEventProps}
                />
            </div>
        </div>
    );
};
